import React from 'react';
import { Layout } from '../../../queries/ats/layout/types';
import { classes } from '../../../utils/commonUtils';
import { AtsItemOverwrites } from '../ats-asset/atsAsset.interfaces';
import { AtsImage } from '../AtsImage';
import { AtsItem } from '../AtsItem';
import styles from './AtsStreamingService.module.scss';

export interface AtsStreamingServiceProps {
  item: Layout.SectionItem;
  pattern: Layout.Pattern;
  overwrites?: AtsItemOverwrites;
}

export function AtsStreamingService({ item, pattern, overwrites, ...rest }: AtsStreamingServiceProps) {
  if (item.type === 'page') {
    return (
      <AtsItem item={item} pattern={pattern} className={styles.link} overwrites={overwrites} {...rest}>
        <AtsImage className={styles.image} item={item} pattern={pattern} />
        {item.params !== null && item.params.behavior === 'see-all' && <div className={styles.title}>{item.name}</div>}
      </AtsItem>
    );
  }

  return (
    <AtsItem item={item} pattern={pattern} className={styles.link} overwrites={overwrites} {...rest}>
      <AtsImage className={styles.image} item={item} pattern={pattern} />
    </AtsItem>
  );
}

export function AtsStreamingServiceSkeleton({ pattern }: Pick<AtsStreamingServiceProps, 'pattern'>) {
  return (
    <div className={classes(styles.skeleton, styles.link)}>
      <div className={styles.image} />
    </div>
  );
}

AtsStreamingService.Skeleton = AtsStreamingServiceSkeleton;
